import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React, { useState } from 'react';
import { useBreakpointValue, Box, Flex, Button, Checkbox } from '@chakra-ui/react';
import Typography from './Typography.js';
import Phone from '../icons/Phone.js';
import CloseIcon from '../icons/CloseIcon.js';

// Checkbox styles
var CHECKBOX_STYLES = {
    '& .chakra-checkbox__control': {
        borderColor: 'white',
        bg: 'transparent',
        borderWidth: '1px',
        _checked: {
            bg: 'white !important',
            borderColor: 'white !important',
            color: 'black !important',
            _hover: {
                bg: 'white !important',
                borderColor: 'white !important',
            }
        },
        _hover: {
            borderColor: 'white',
            bg: 'transparent',
        }
    },
    '& .chakra-checkbox__control[data-checked]': {
        bg: 'white !important',
        borderColor: 'white !important',
    },
    '& .chakra-checkbox__control[data-checked] svg': {
        color: '#4C4CE6 !important',
        stroke: 'black !important',
    }
};
var BookDemoBanner = function (_a) {
    var title = _a.title, description = _a.description, buttonText = _a.buttonText, onButtonClick = _a.onButtonClick, buttonUrl = _a.buttonUrl, _b = _a.isVertical, isVertical = _b === void 0 ? false : _b, icon = _a.icon, onClose = _a.onClose, _c = _a.width, width = _c === void 0 ? "100%" : _c, _d = _a.height, height = _d === void 0 ? "auto" : _d, styles = _a.styles, _e = _a.showCheckbox, showCheckbox = _e === void 0 ? false : _e, checkboxText = _a.checkboxText, onCheckboxChange = _a.onCheckboxChange, _f = _a.defaultChecked, defaultChecked = _f === void 0 ? false : _f;
    // Responsive breakpoint for mobile
    var isMobile = useBreakpointValue({ base: true, md: false });
    // Determine if we should use vertical layout
    var shouldUseVerticalLayout = isVertical || isMobile;
    // Checkbox state
    var _g = useState(defaultChecked), isChecked = _g[0], setIsChecked = _g[1];
    // Event handlers
    var handleButtonClick = function () {
        if (buttonUrl) {
            window.open(buttonUrl, '_blank');
        }
        if (onButtonClick) {
            onButtonClick();
        }
    };
    var handleCheckboxChange = function (e) {
        var checked = e.target.checked;
        setIsChecked(checked);
        onCheckboxChange === null || onCheckboxChange === void 0 ? void 0 : onCheckboxChange(checked);
    };
    var handleCloseClick = function () {
        onClose === null || onClose === void 0 ? void 0 : onClose(isChecked);
    };
    // Component definitions
    var CloseButton = function () { return (React.createElement(CloseIcon, { height: "17px", width: "17px", cursor: "pointer", color: "white", onClick: handleCloseClick })); };
    var IconComponent = function () { return (React.createElement(Flex, { justify: "center", align: "center", w: "44px", h: "44px", bg: "#6d6dca", borderRadius: "50%", backdropFilter: "blur(10px)" }, icon || React.createElement(Phone, { color: "white" }))); };
    var ContentSection = function () { return (React.createElement(Flex, { direction: "column", align: "flex-start", wordBreak: "break-word" },
        React.createElement(Typography, { variant: "h3-r-medium", color: "white" }, title),
        description && (React.createElement(Typography, { variant: "h3-i-medium", color: "white", fontSize: '14px', fontWeight: 400, lineHeight: '19px', mt: "8px" }, description)))); };
    var ActionButton = function () { return (React.createElement(Button, { bg: "neutrals.white", variant: "secondary", color: "neutrals.900", fontWeight: 500, borderRadius: "8px", px: shouldUseVerticalLayout ? "24px" : "16px", py: shouldUseVerticalLayout ? "12px" : "8px", boxShadow: "0 1px 0 0 rgba(0, 0, 0, 0.25)", border: "1px solid", borderColor: "neutrals.500", _hover: {
            borderColor: "neutrals.600",
            color: 'neutrals.700'
        }, transition: "all 0.2s ease", onClick: handleButtonClick, whiteSpace: "normal", w: "auto", minH: "36px", flexShrink: 0, h: "auto", wordBreak: "break-word" },
        React.createElement(Typography, { variant: "h3-i-medium", color: "inherit", fontSize: "16px", lineHeight: "20px" }, buttonText))); };
    var CheckboxSection = function () { return (React.createElement(Box, { width: "fit-content", h: '18px' },
        React.createElement(Checkbox, { isChecked: isChecked, onChange: handleCheckboxChange, sx: CHECKBOX_STYLES },
            React.createElement(Typography, { variant: "h3-i-medium", color: "white", fontSize: "14px", fontWeight: 400, lineHeight: "19px" }, checkboxText)))); };
    // Layout components
    var VerticalLayout = function () { return (React.createElement(Flex, { direction: "column", h: "100%", w: "100%", gap: "16px", mr: "16px", align: "flex-start" },
        React.createElement(ContentSection, null),
        React.createElement(Box, { alignSelf: "flex-start" },
            React.createElement(ActionButton, null)),
        showCheckbox && React.createElement(CheckboxSection, null))); };
    var HorizontalLayout = function () { return (React.createElement(Flex, { direction: "row", align: "center", justify: "center", gap: "16px", flex: 1, mr: "16px" },
        React.createElement(Flex, { direction: "column", h: "100%", w: "100%", gap: "16px" },
            React.createElement(ContentSection, null),
            showCheckbox && React.createElement(CheckboxSection, null)),
        React.createElement(ActionButton, null))); };
    return (React.createElement(Box, __assign({ position: "relative", width: width, height: height, background: "linear-gradient(90deg, #1B1BAA 0%, #4C4CE6 100%);", borderRadius: "8px", overflow: "hidden", p: "16px", display: "flex", alignItems: "flex-start" }, styles),
        !shouldUseVerticalLayout && (React.createElement(Box, { marginRight: "16px" },
            React.createElement(IconComponent, null))),
        shouldUseVerticalLayout ? React.createElement(VerticalLayout, null) : React.createElement(HorizontalLayout, null),
        onClose && React.createElement(CloseButton, null)));
};

export { BookDemoBanner as default };
//# sourceMappingURL=BookDemoBanner.js.map
